/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security/detect-object-injection */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useCallback, useState, useEffect
} from 'react';
import _ from 'lodash';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, useCheckSubmissionVMDirty } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierPL-react/config/PremierPL-wizard-config.json5";
import { PremierConstants } from 'premier-constant-service';
import metadata from './PersonalCyberliabilityPage.metadata.json5';
import styles from './PersonalCyberliabilityPage.module.scss';
import ProductandcoveragesselectionComponent from "../../components/CyberLiabilityPersonal/Productandcoveragesselection/ProductandcoveragesselectionComponent"

import TechnicalAssessmentComponent from "../../components/CyberLiabilityPersonal/TechnicalAssessment/TechnicalAssessmentComponent"
import InternalUseOnlyComponent from "../../components/CyberLiabilityPersonal/InternalUseOnly/InternalUseOnlyComponent"
import CoveragesPageComponent from '../Coverages/CoveragesPage';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function PersonalCyberliabilityPage(props) {

    const { wizardData:  submissionVM, updateWizardData} = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const translator = useTranslator();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { updateSubmission, saveAndQuoteSubmissionService } = useUpdateSubmissionServices();
    const jobNumber = submissionVM.value?.quoteID || submissionVM.value?.jobID;
    const { isDirty } = useCheckSubmissionVMDirty(submissionVM.value);
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('property'));
    const { lineName } = PremierConstants;
   //  const modelVM = _.get(submissionVM, pathUpdated)

    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation,
        isComponentValid
    } = useValidation('PersonalCyberliabilityPage');

   

    const onNext = useCallback(
        async () => {           

            const {productCode} = submissionVM.value.baseData;
            const lobLineName = lineName[productCode];

            submissionVM.value = await updateSubmission(lobLineName, 'PersonalCyberliabilityPage', submissionVM);
            return submissionVM;
        },
        [submissionVM]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        productandcoveragesselectionComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.cybLiaLine.coverables.perRsks.children[0].exposures.pclproAndCovSelExps.children[0]"
        },
        technicalAssessmentComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.cybLiaLine.coverables.perRsks.children[0].exposures.pclrisInfExps.children[0]"
        },
        internalUseOnlyComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.cybLiaLine.coverables.perRsks.children[0].intUseOnlRsks.children[0].exposures"
        },
        [`coveragesPageComponent`] : {
            wizardData: submissionVM,
            updateWizardData,
            clausesBasePath: `lobData.cybLiaLine.lineCoverages.cybLiaClausesGroups`
        }

    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productandcoveragesselectionComponent: ProductandcoveragesselectionComponent,
            technicalAssessmentComponent:TechnicalAssessmentComponent,
            internalUseOnlyComponent:InternalUseOnlyComponent,
             coveragesPageComponent:CoveragesPageComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
           (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
           [metadata.pageContent, submissionVM, overrideProps]
       );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            //const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${changedPath}`, value);

            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

   return (
              <ViewModelForm
                   uiProps={metadata.pageContent}
                   model={submissionVM}
                   onModelChange={updateWizardData}
                   overrideProps={overrideProps}
                   onValidationChange={onValidate}
                   resolveValue={readValue}
                   callbackMap={resolvers.resolveCallbackMap}
                   componentMap={resolvers.resolveComponentMap}
                   classNameMap={resolvers.resolveClassNameMap}
               />
       );
}

PersonalCyberliabilityPage.propTypes = wizardProps;
export default withRouter(PersonalCyberliabilityPage);
